<script>
  import { FirebaseApp, User, Doc, Collection } from "sveltefire";
  import { Router, Route } from "svelte-routing";

  import firebase from "firebase/app";
  import "firebase/firestore";
  import "firebase/auth";
  import "firebase/performance";
  import "firebase/analytics";

  import NoUserDataFallback from "./NoUserDataFallback.svelte";
  import NavBar from "./NavBar.svelte";
  import PageDashboard from "./pages/PageDashboard.svelte";
  import PageOrder from "./pages/PageOrder.svelte";
  import PageRedirect from "./pages/PageRedirect.svelte";
  import PageLogin from "./pages/PageLogin.svelte";
  import PageRegister from "./pages/PageRegister.svelte";

  const firebaseConfig = {
    apiKey: "AIzaSyByTDlGy7M9f21XqPouLBIC5MznCycQYrI",
    authDomain: "pausenhelden.firebaseapp.com",
    projectId: "pausenhelden",
    storageBucket: "pausenhelden.appspot.com",
    messagingSenderId: "476937268631",
    appId: "1:476937268631:web:0b5be3513029593068a8d2",
    measurementId: "G-F41BFP12M7",
  };

  firebase.initializeApp(firebaseConfig);

  let registerData;
  function handleRegisterEvent(event) {
    registerData = event.detail;
  }


  //https://www.unixtimestamp.com/
  let orderFrames = [
	{
		"id": 1,
		"availableBegin": 1601157600,
		"availableEnd": 1639090800,
		"dateBegin": 1641769200,
		"dateEnd": 1643929200,
		"weekNoBegin": 2,
		"weekNoEnd": 5,
		"weekSlices": [
			{
				"weekNo": 2,
				"regularSchoolDays": 5,
				"dateBegin": 1641769200,
				"dateEnd": 1642114800
			},
			{
				"weekNo": 3,
				"regularSchoolDays": 5,
				"dateBegin": 1642374000,
				"dateEnd": 1642719600
			},
			{
				"weekNo": 4,
				"regularSchoolDays": 5,
				"dateBegin": 1642978800,
				"dateEnd": 1643324400
			},
			{
				"weekNo": 5,
				"regularSchoolDays": 5,
				"dateBegin": 1643583600,
				"dateEnd": 1643929200
			}
		]
	},
	{
		"id": 2,
		"availableBegin": 1632693600,
		"availableEnd": 1642114800,
		"dateBegin": 1644188400,
		"dateEnd": 1646348400,
		"weekNoBegin": 6,
		"weekNoEnd": 9,
		"weekSlices": [
			{
				"weekNo": 6,
				"regularSchoolDays": 5,
				"dateBegin": 1644188400,
				"dateEnd": 1644534000
			},
			{
				"weekNo": 7,
				"regularSchoolDays": 5,
				"dateBegin": 1644793200,
				"dateEnd": 1645138800
			},
			{
				"weekNo": 8,
				"regularSchoolDays": 5,
				"dateBegin": 1645398000,
				"dateEnd": 1645743600
			},
			{
				"weekNo": 9,
				"regularSchoolDays": 5,
				"dateBegin": 1646002800,
				"dateEnd": 1646348400
			}
		]
	},
	{
		"id": 3,
		"availableBegin": 1632693600,
		"availableEnd": 1644534000,
		"dateBegin": 1646607600,
		"dateEnd": 1648764000,
		"weekNoBegin": 10,
		"weekNoEnd": 13,
		"weekSlices": [
			{
				"weekNo": 10,
				"regularSchoolDays": 5,
				"dateBegin": 1646607600,
				"dateEnd": 1646953200
			},
			{
				"weekNo": 11,
				"regularSchoolDays": 5,
				"dateBegin": 1647212400,
				"dateEnd": 1647558000
			},
			{
				"weekNo": 12,
				"regularSchoolDays": 5,
				"dateBegin": 1647817200,
				"dateEnd": 1648162800
			},
			{
				"weekNo": 13,
				"regularSchoolDays": 5,
				"dateBegin": 1648418400,
				"dateEnd": 1648764000
			}
		]
	}
];
</script>

<Router url={""}>
  <FirebaseApp {firebase}>
    <User let:user let:auth>
      <div slot="signed-out">
        <NavBar />
        <Route path="login">
          <PageLogin {auth} />
        </Route>
        <Route path="register">
          <PageRegister {auth} on:registered={handleRegisterEvent} />
        </Route>
        <Route path="*">
          <PageRedirect target={"/login"} />
        </Route>
      </div>

      <NavBar>
        <button
          class="btn btn-specialOrange btn-logout"
          on:click={() => auth.signOut()}>Logout</button
        >
      </NavBar>
      <Doc path={`users/${user.uid}`} let:data={userdata} let:ref={userRef} log>
        <span slot="loading">Loading data...</span>
        <span slot="fallback">
          <!-- used to update the registerData manually -->
          <NoUserDataFallback {userRef} {registerData} />
        </span>

          <!--
            orders und ordersRef ab hier verfügbar
            löschbar mit orders[0].ref.delete()
            neu erstellbar mit ordersRef.add({...})
          -->

          <main>
            <section class="container text-center">
              <Route path="dashboard">
                <PageDashboard {userdata} {userRef} {orderFrames} />
              </Route>
              <Route path="order/:orderFrameId" let:params>
                <PageOrder userId={user.uid} {userdata} {userRef} orderFrame={orderFrames.find( (el) => el.id == params.orderFrameId)}/>
              </Route>
              <Route path="*">
                <PageRedirect target={"/dashboard"} />
              </Route>
            </section>
          </main>

      </Doc>
    </User>
  </FirebaseApp>
</Router>

<style>
  .btn-logout {
    margin-top: 8px;
  }
</style>
